/* Native, isolated section lifecycle. No external animation library. */
(() => {
  if (customElements.get('cn-christmas-shop')) return;
  class CannonChristmas extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.cards = Array.from(this.querySelectorAll('[data-cnx-card]'));
      this.cards.forEach((card, index) => { card.dataset.order = String(index); });
      this.filter = 'all';
      this.sort = this.querySelector('[data-cnx-sort]');
      this.grid = this.querySelector('.cnx-grid');
      this.querySelector('[data-cnx-tools]').hidden = false;
      this.querySelectorAll('[data-cnx-filter]').forEach(button => {
        button.addEventListener('click', () => {
          this.filter = button.dataset.cnxFilter;
          this.querySelectorAll('[data-cnx-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          this.updateProducts();
        }, { signal });
      });
      this.sort.addEventListener('change', () => this.updateProducts(), { signal });
      this.updateProducts();
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.toggle = this.querySelector('[data-cnx-motion]');
      this.userPaused = false;
      try { this.userPaused = sessionStorage.getItem('cn-christmas-paused') === 'true'; } catch (_) { /* Storage may be unavailable. */ }
      this.toggle.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        try { sessionStorage.setItem('cn-christmas-paused', String(this.userPaused)); } catch (_) { /* Animation still works. */ }
        this.updateMotion();
      }, { signal });
      this.motion.addEventListener('change', () => this.buildWeather(), { signal });
      this.mobile.addEventListener('change', () => this.buildWeather(), { signal });
      document.addEventListener('visibilitychange', () => this.updateMotion(), { signal });
      this.buildWeather();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.querySelector('.cnx-weather')?.replaceChildren();
    }
    updateProducts() {
      const order = this.sort.value;
      const sorted = [...this.cards].sort((a, b) => {
        const stock = Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true');
        if (stock) return stock;
        if (order === 'price-low') return Number(a.dataset.price) - Number(b.dataset.price);
        if (order === 'price-high') return Number(b.dataset.price) - Number(a.dataset.price);
        if (order === 'title') return a.dataset.title.localeCompare(b.dataset.title);
        return Number(a.dataset.order) - Number(b.dataset.order);
      });
      let shown = 0;
      sorted.forEach(card => {
        const matches = this.filter === 'all' || (this.filter === 'budget' ? Number(card.dataset.price) < 2000 : card.dataset.category === this.filter);
        card.hidden = !matches;
        if (matches) shown++;
        this.grid.appendChild(card);
      });
      this.querySelector('[data-cnx-count]').textContent = `${shown} ${shown === 1 ? 'gift' : 'gifts'}${this.filter === 'budget' ? ' from under £20' : ''}`;
      this.querySelector('[data-cnx-empty]').hidden = shown !== 0;
    }
    buildWeather() {
      const weather = this.querySelector('.cnx-weather');
      weather.replaceChildren();
      if (this.dataset.animation !== 'true' || this.motion.matches) { this.updateMotion(); return; }
      const total = Math.min(30, Math.max(8, Number(this.dataset.density) || 18));
      const count = this.mobile.matches ? Math.max(6, Math.round(total * .45)) : total;
      const speed = Math.min(45, Math.max(15, Number(this.dataset.speed) || 28));
      const ns = 'http://www.w3.org/2000/svg';
      for (let i = 0; i < count; i++) {
        const ball = i % 7 === 0;
        const particle = document.createElement('span');
        particle.className = `cnx-particle cnx-particle--${ball ? 'ball' : 'snow'}`;
        particle.style.setProperty('--cnx-left', `${(i * 61.803) % 112 - 8}%`);
        particle.style.setProperty('--cnx-size', `${ball ? 10 + i % 7 : 15 + i % 13}px`);
        particle.style.setProperty('--cnx-time', `${speed + i % 11}s`);
        particle.style.setProperty('--cnx-delay', `${-((i * 7.7) % speed)}s`);
        const svg = document.createElementNS(ns, 'svg');
        svg.setAttribute('viewBox', '0 0 32 32');
        svg.setAttribute('focusable', 'false');
        if (ball) {
          const circle = document.createElementNS(ns, 'circle');
          circle.setAttribute('cx', '16'); circle.setAttribute('cy', '16'); circle.setAttribute('r', '12'); circle.setAttribute('fill', 'currentColor');
          const shine = document.createElementNS(ns, 'path');
          shine.setAttribute('d', 'M9 14a8 8 0 0 1 5-5'); shine.setAttribute('fill', 'none'); shine.setAttribute('stroke', '#eee2c9'); shine.setAttribute('stroke-width', '2'); shine.setAttribute('stroke-linecap', 'round');
          svg.append(circle, shine);
        } else {
          for (let ray = 0; ray < 6; ray++) {
            const path = document.createElementNS(ns, 'path');
            path.setAttribute('d', 'M16 16V3M16 9l-4-4M16 9l4-4');
            path.setAttribute('transform', `rotate(${ray * 60} 16 16)`);
            path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor'); path.setAttribute('stroke-width', '1.4'); path.setAttribute('stroke-linecap', 'round');
            svg.appendChild(path);
          }
        }
        particle.appendChild(svg); weather.appendChild(particle);
      }
      this.updateMotion();
    }
    updateMotion() {
      const disabled = this.dataset.animation !== 'true' || this.motion.matches;
      this.toggle.hidden = disabled;
      this.dataset.motionOff = String(disabled);
      this.dataset.paused = String(this.userPaused || document.hidden);
      this.toggle.textContent = this.userPaused ? 'Play animation' : 'Pause animation';
      this.toggle.setAttribute('aria-pressed', String(this.userPaused));
    }
  }
  customElements.define('cn-christmas-shop', CannonChristmas);
})();
